export default {
    computed: {
    },

    methods: {

        mx_faceted_filter(filters){
            // console.log(filters);
            let filter_uri = '';
            let gap = 0;
            for (const prop in filters) {
                
                // if(filters[prop].length > 0){
                    if(Array.isArray(filters[prop]) === true){
                        filters[prop].forEach(f => {
                            switch(prop){
                                case 'PartTypes':
                                    filter_uri += '&fq=IGDESC:*' + this.clean_str(f) + '*';
                                break;
                                case 'Colors':
                                    filter_uri += '&fq=Color:' + this.clean_str(f);
                                break;
                                case 'Brands':
                                    filter_uri += '&fq=MCNAME:' + this.clean_str(f);
                                break;
                                case 'Prices':
                                    // gap = this.facets.facet_ranges.B2C_price.gap;
                                    // B2C_price:[0%20TO%20100]
                                    gap = 100;
                                    filter_uri += '&fq=B2C_price:['+f+' TO ' + (parseFloat(f) + parseFloat(gap))  + ']';
                                break;
                                case 'Weights':
                                    // gap = this.facets.facet_ranges.Weight.gap;
                                    gap = 10;
                                    // B2C_price:[0%20TO%20100]
                                    filter_uri += '&fq=B2C_price:['+f+' TO ' + (parseFloat(f) + parseFloat(gap))  + ']';
                                break;
                                default:
                                    console.log('default ' + prop + ' = ' + f);
                                    filter_uri += '&fq='+prop+':' + this.clean_str(f);
                                    break;
                            }
                        })
                    }else if(typeof filters[prop] === 'boolean'){
                        switch(prop){
                            case 'Available':
                                if (filters[prop] == true){
                                    filter_uri += '&fq=Stocks:[1 TO *]';
                                }
                            break;
                            case 'Stocks':
                                // if (filters[prop] == true){
                                //     filter_uri += '&fq=Stocking_Flag: Y';
                                // }
                            break;
                        }

                    }else{
                        switch(prop){
                            case 'Available':
                                // console.log('Available = ' + filters[prop]);
                                if (filters[prop] == 'Y'){
                                    filter_uri += '&fq=Stocks:[1 TO *]';
                                }else{
                                    filter_uri += '&fq=Stocks:[0 TO *]';
                                }
                            break;
                            case 'Stocks':
                                if(filters[prop] == 'Y'){
                                    // filter_uri += '&fq=Stocks:[1 TO *]';
                                    filter_uri += '&fq=Stocking_Flag:' + this.clean_str(filters[prop]);
                                }
                            break;
                            case 'Category':
                                if(filters[prop] != ''){
                                    filter_uri += '&fq=DMCD02:' + this.clean_str(filters[prop]);
                                }
                            break;
                            
                        }
                    }
                // }else{
                //     console.log('custom = ' + prop);
                // }
            }
            console.log('filter uri = ' + filter_uri);
            return  filter_uri;
        },

        mx_url_builder(filters){
            // console.log(filters);
            // &fq=
            let filter_uri = '';
            let gap = 0;
            for (const prop in filters) {
                
                // if(filters[prop].length > 0){
                    if(Array.isArray(filters[prop]) === true){
                        filters[prop].forEach(f => {
                            switch(prop){
                                case 'PartTypes':
                                    filter_uri += '&IGDESC=*' + this.clean_str(f) + '*';
                                break;
                                case 'Colors':
                                    filter_uri += '&Color=' + this.clean_str(f);
                                break;
                                case 'Brands':
                                    filter_uri += '&MCNAME=' + this.clean_str(f);
                                break;
                                case 'Prices':
                                    // gap = this.facets.facet_ranges.B2C_price.gap;
                                    // B2C_price:[0%20TO%20100]
                                    gap = 100;
                                    filter_uri += '&B2C_price=['+f+' TO ' + (parseFloat(f) + parseFloat(gap))  + ']';
                                break;
                                case 'Weights':
                                    // gap = this.facets.facet_ranges.Weight.gap;
                                    gap = 10;
                                    // B2C_price:[0%20TO%20100]
                                    filter_uri += '&B2C_price=['+f+' TO ' + (parseFloat(f) + parseFloat(gap))  + ']';
                                break;
                                default:
                                    filter_uri += '&'+prop+'=' + this.clean_str(f);
                                    break;
                            }
                        })
                    }else if(typeof filters[prop] === 'boolean'){
                        switch(prop){
                            case 'Available':
                                if (filters[prop] == true){
                                    filter_uri += '&Stocks=[1 TO *]';
                                }
                            break;
                            case 'Stocks':
                                // if (filters[prop] == true){
                                //     filter_uri += '&Stocking_Flag=Y';
                                // }
                            break;
                        }

                    }else{
                        switch(prop){
                            case 'Available':
                                // console.log('Available = ' + filters[prop]);
                                if (filters[prop] == 'Y'){
                                    filter_uri += '&Stocks=[1 TO *]';
                                }else{
                                    filter_uri += '&Stocks=[0 TO *]';
                                }
                            break;
                            case 'Stocks':
                                if(filters[prop] == 'Y'){
                                    // filter_uri += '&fq=Stocks:[1 TO *]';
                                    filter_uri += '&Stocking_Flag=' + this.clean_str(filters[prop]);
                                }
                            break;
                            case 'Category':
                                if(filters[prop] != ''){
                                    filter_uri += '&DMCD02=' + this.clean_str(filters[prop]);
                                }
                            break;
                            
                        }
                    }
                // }else{
                //     console.log('custom = ' + prop);
                // }
            }

            return  filter_uri;
        },

        mx_get_filter(){
            let uri = '';
            for(const f in this.$route.query){
                // console.log(f);
                if(f == "")
                    continue;
                    
                uri += '&fq='+f+':'+this.$route.query[f];
            }
            return uri;
        },

        clean_str(val){
            let newVal = val.trim().replaceAll(' ', '\\ ');
            newVal = newVal.replaceAll('&', '%26');
            return newVal;
        },

        mfclean_str(val){
            let newVal = val;
            // .trim().replaceAll(' ', '\\ ');
            newVal = newVal.replaceAll('&', '%26');
            return newVal;
        },

        mx_multi_facet_filter(filters){
            let filter_uri = '&fq=';
            let multi_uri = '';
            let filter_queries = [];
            let gap = 0;
            for (const prop in filters) {
                // if(filters[prop].length > 0){
                    // {!tag=IGDESC}IGDESC:\"SAWS GRINDERS & ACC\" OR IGDESC:\"CIRCUIT BREAKERS\"
                    if(Array.isArray(filters[prop]) === true){
                        filters[prop].forEach(f => {
                            // console.log(f);
                            switch(prop){
                                case 'PartTypes':
                                    // filter_uri += 'IGDESC:*' + this.clean_str(f) + '*';
                                    if(filter_queries['IGDESC'] == undefined){
                                        filter_queries['IGDESC'] = '&fq={!tag=IGDESC}IGDESC:"' + this.mfclean_str(f) + '"';
                                    }else{
                                        filter_queries['IGDESC'] += ' OR IGDESC:"' + this.mfclean_str(f) + '"';
                                    }
                                break;
                                case 'Colors':
                                    filter_uri += 'Color:' + this.mfclean_str(f);
                                break;
                                case 'Brands':
                                    // filter_uri += 'MCNAME:' + this.clean_str(f);

                                    if(filter_queries['MCNAME'] == undefined){
                                        filter_queries['MCNAME'] = '&fq={!tag=MCNAME}MCNAME:"' + this.mfclean_str(f) + '"';
                                    }else{
                                        filter_queries['MCNAME'] += ' OR MCNAME:"' + this.mfclean_str(f) + '"';
                                    }
                                break;
                                case 'Prices':
                                    // gap = this.facets.facet_ranges.B2C_price.gap;
                                    // B2C_price:[0%20TO%20100]
                                    gap = 100;
                                    filter_uri += 'B2C_price:['+f+' TO ' + (parseFloat(f) + parseFloat(gap))  + ']';
                                break;
                                case 'Weights':
                                    // gap = this.facets.facet_ranges.Weight.gap;
                                    gap = 10;
                                    // B2C_price:[0%20TO%20100]
                                    filter_uri += 'B2C_price:['+f+' TO ' + (parseFloat(f) + parseFloat(gap))  + ']';
                                break;
                                default:
                                    // console.log('default ' + prop + ' = ' + f);
                                    // filter_uri += prop+':' + this.clean_str(f);

                                    if(filter_queries[prop] == undefined){
                                        filter_queries[prop] = '&fq={!tag='+prop+'}'+prop+':"' + this.mfclean_str(f) + '"';
                                    }else{
                                        filter_queries[prop] += ' OR '+prop+':"' + this.mfclean_str(f) + '"';
                                    }
                                break;
                            }
                        })
                    }else if(typeof filters[prop] === 'boolean'){
                        switch(prop){
                            case 'Available':
                                if (filters[prop] == true){
                                    filter_uri += '&fq=Stocks:[1 TO *]';
                                }
                            break;
                            case 'Stocks':
                                if (filters[prop] == true){
                                    filter_uri += '&fq=Stocking_Flag: Y';
                                    // filter_uri += '{!tag=Stocking_Flag}Stocking_Flag:Y';
                                }
                            break;
                        }

                    }else{
                        switch(prop){
                            case 'Available':
                                // console.log('Available = ' + filters[prop]);
                                if (filters[prop] == 'Y'){
                                    filter_uri += 'Stocks:[1 TO *]';
                                }else{
                                    filter_uri += 'Stocks:[0 TO *]';
                                }
                            break;
                            case 'Stocks':
                                // if(filters[prop] == 'Y'){
                                //     filter_uri += 'Stocking_Flag:' + this.clean_str(filters[prop]);
                                // }
                            break;
                            case 'Category':
                                if(filters[prop] != ''){
                                    filter_uri += 'DMCD02:' + this.clean_str(filters[prop]);
                                }
                            break;
                            
                        }
                    }
                // }else{
                //     console.log('custom = ' + prop);
                // }
            }
            
            for (const fq in filter_queries) {
                multi_uri += filter_queries[fq];
            }
        
            filter_uri += multi_uri;
            console.log('filter uri = ' + filter_uri);
            return  filter_uri;
        },

        mx_json_facet(ffields) {
            let json_uri = '&json.facet=';
            json_uri += '{';
            ffields.forEach(fq => {
                json_uri += fq + ':{type:terms, field:' + fq + ', excludeTags:' + fq + ', limit:-1},';
            });
            json_uri += '}';

            return json_uri;
        }
    }
}